import { Tabs } from '@repo/ui/components/tabs';
import { route as routeConfig } from './config';
import { route as routePosConfig } from './pos';
import { urlConfig } from '@/urls';
import { Outlet } from 'react-router';
import { useCurrentClub } from '@/hooks/use-current-club';

function ConfigLayout() {
  const club = useCurrentClub();
  return (
    <div className="flex flex-col gap-4 h-full">
      <Tabs
        tabs={[
          { label: 'Configuración', link: urlConfig(club.id) },
          { label: 'POS', link: urlConfig(club.id, 'pos') },
        ]}
      />
      <Outlet />
    </div>
  );
}

export const route = {
  element: <ConfigLayout />,
  children: [routeConfig, routePosConfig],
};
